// extracted by mini-css-extract-plugin
export default {"pagelock_footer":"EmptyPageFinder_pagelock_footer__Px3QU"};